// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Nodes palette dock — dark surfaces */

.F9DcSHOzglF_jx17kwR5 {
    position: relative;
    width: calc(100% - 16px);
    margin: 0 8px 8px;
    box-sizing: border-box;
}

.N_zFdWJs4T2o1b7np70z {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 8px;
    width: 100%;
    box-sizing: border-box;
    text-align: left;
    font-size: 10px;
    font-weight: 600;
    padding: 8px 10px;
    border-radius: 4px;
    border: 1px solid rgba(255, 255, 255, 0.18);
    background: rgba(0, 0, 0, 0.35);
    color: #fbfcf6;
    cursor: pointer;
    font-family: inherit;
}

.N_zFdWJs4T2o1b7np70z:focus {
    outline: none;
    border-color: rgba(251, 170, 105, 0.75);
    box-shadow: 0 0 0 2px rgba(251, 170, 105, 0.2);
}

.abT_VZFWIZUgVBWNE_7N {
    flex: 1;
    min-width: 0;
    white-space: normal;
    overflow-wrap: anywhere;
    word-break: break-word;
    line-height: 1.35;
}

.UxMrrec4GZLqkWnM90zW {
    flex-shrink: 0;
    font-size: 9px;
    opacity: 0.85;
    margin-top: 2px;
    transition: transform 0.15s ease;
}

.OKySlBLboI4bZdZ2lTjf {
    transform: rotate(180deg);
}

.MsNPImPVcMiVdMbJD3hw {
    position: absolute;
    left: 0;
    right: 0;
    z-index: 20;
    margin-top: 4px;
    max-height: min(240px, 40vh);
    overflow-y: auto;
    overflow-x: hidden;
    padding: 4px;
    border-radius: 4px;
    border: 1px solid rgba(255, 255, 255, 0.18);
    background: #1e1f23;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.45);
    display: flex;
    flex-direction: column;
    gap: 2px;
}

.WnnYiAEF0S5a13Q_pH8F {
    display: block;
    width: 100%;
    box-sizing: border-box;
    text-align: left;
    white-space: normal;
    overflow-wrap: anywhere;
    word-break: break-word;
    line-height: 1.35;
    padding: 8px 10px;
    margin: 0;
    border: none;
    border-radius: 4px;
    background: transparent;
    color: #fbfcf6;
    font-size: 10px;
    font-weight: 600;
    font-family: inherit;
    cursor: pointer;
}

.WnnYiAEF0S5a13Q_pH8F:hover {
    background: rgba(255, 255, 255, 0.08);
}

.QSeYbUnCX7GNFDYAGiJv {
    background: rgba(251, 170, 105, 0.18);
    color: #fbaa69;
}

.WnnYiAEF0S5a13Q_pH8F:focus {
    outline: none;
    box-shadow: inset 0 0 0 2px rgba(251, 170, 105, 0.45);
}
`, "",{"version":3,"sources":["webpack://./src/components/packages/ForkFamilyPicker.dock.module.css"],"names":[],"mappings":"AAAA,uCAAuC;;AAEvC;IACI,kBAAkB;IAClB,wBAAwB;IACxB,iBAAiB;IACjB,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,8BAA8B;IAC9B,QAAQ;IACR,WAAW;IACX,sBAAsB;IACtB,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,2CAA2C;IAC3C,+BAA+B;IAC/B,cAAc;IACd,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,uCAAuC;IACvC,8CAA8C;AAClD;;AAEA;IACI,OAAO;IACP,YAAY;IACZ,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;IACtB,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,cAAc;IACd,aAAa;IACb,eAAe;IACf,gCAAgC;AACpC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,WAAW;IACX,eAAe;IACf,4BAA4B;IAC5B,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,2CAA2C;IAC3C,mBAAmB;IACnB,0CAA0C;IAC1C,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,cAAc;IACd,WAAW;IACX,sBAAsB;IACtB,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;IACtB,iBAAiB;IACjB,iBAAiB;IACjB,SAAS;IACT,YAAY;IACZ,kBAAkB;IAClB,uBAAuB;IACvB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,eAAe;AACnB;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,qCAAqC;IACrC,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,qDAAqD;AACzD","sourcesContent":["/* Nodes palette dock — dark surfaces */\n\n.root {\n    position: relative;\n    width: calc(100% - 16px);\n    margin: 0 8px 8px;\n    box-sizing: border-box;\n}\n\n.trigger {\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-between;\n    gap: 8px;\n    width: 100%;\n    box-sizing: border-box;\n    text-align: left;\n    font-size: 10px;\n    font-weight: 600;\n    padding: 8px 10px;\n    border-radius: 4px;\n    border: 1px solid rgba(255, 255, 255, 0.18);\n    background: rgba(0, 0, 0, 0.35);\n    color: #fbfcf6;\n    cursor: pointer;\n    font-family: inherit;\n}\n\n.trigger:focus {\n    outline: none;\n    border-color: rgba(251, 170, 105, 0.75);\n    box-shadow: 0 0 0 2px rgba(251, 170, 105, 0.2);\n}\n\n.triggerLabel {\n    flex: 1;\n    min-width: 0;\n    white-space: normal;\n    overflow-wrap: anywhere;\n    word-break: break-word;\n    line-height: 1.35;\n}\n\n.triggerChevron {\n    flex-shrink: 0;\n    font-size: 9px;\n    opacity: 0.85;\n    margin-top: 2px;\n    transition: transform 0.15s ease;\n}\n\n.triggerChevronOpen {\n    transform: rotate(180deg);\n}\n\n.listbox {\n    position: absolute;\n    left: 0;\n    right: 0;\n    z-index: 20;\n    margin-top: 4px;\n    max-height: min(240px, 40vh);\n    overflow-y: auto;\n    overflow-x: hidden;\n    padding: 4px;\n    border-radius: 4px;\n    border: 1px solid rgba(255, 255, 255, 0.18);\n    background: #1e1f23;\n    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.45);\n    display: flex;\n    flex-direction: column;\n    gap: 2px;\n}\n\n.option {\n    display: block;\n    width: 100%;\n    box-sizing: border-box;\n    text-align: left;\n    white-space: normal;\n    overflow-wrap: anywhere;\n    word-break: break-word;\n    line-height: 1.35;\n    padding: 8px 10px;\n    margin: 0;\n    border: none;\n    border-radius: 4px;\n    background: transparent;\n    color: #fbfcf6;\n    font-size: 10px;\n    font-weight: 600;\n    font-family: inherit;\n    cursor: pointer;\n}\n\n.option:hover {\n    background: rgba(255, 255, 255, 0.08);\n}\n\n.optionSelected {\n    background: rgba(251, 170, 105, 0.18);\n    color: #fbaa69;\n}\n\n.option:focus {\n    outline: none;\n    box-shadow: inset 0 0 0 2px rgba(251, 170, 105, 0.45);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `F9DcSHOzglF_jx17kwR5`,
	"trigger": `N_zFdWJs4T2o1b7np70z`,
	"triggerLabel": `abT_VZFWIZUgVBWNE_7N`,
	"triggerChevron": `UxMrrec4GZLqkWnM90zW`,
	"triggerChevronOpen": `OKySlBLboI4bZdZ2lTjf`,
	"listbox": `MsNPImPVcMiVdMbJD3hw`,
	"option": `WnnYiAEF0S5a13Q_pH8F`,
	"optionSelected": `QSeYbUnCX7GNFDYAGiJv`
};
export default ___CSS_LOADER_EXPORT___;
